// @flow
import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
// eslint-disable-next-line no-unused-vars
import VConsole from 'vconsole'
import { container } from '@landrover/business/index'
import SAASService from '@services/saas.service'
import wx from 'weixin-js-sdk'
import { lazy } from 'react'

// import routes from '../router'
import WrappedComponent from './WrappedComponent'

import './normalize.css'
import './app.scss'

const routes = {
  details: lazy(() => import(/* webpackChunkName: "details" */ '@pages/details')),
  employeeDetail: lazy(() =>
    import(/* webpackChunkName: "employeeDetail" */ '@pages/employeeDetail')
  ),
  employeeList: lazy(() => import(/* webpackChunkName: "employeeList" */ '@pages/employeeList')),
  example: lazy(() => import(/* webpackChunkName: "example" */ '@pages/example')),
  fileUpTeach: lazy(() => import(/* webpackChunkName: "fileUpTeach" */ '@pages/fileUpTeach')),
  index: lazy(() => import(/* webpackChunkName: "index" */ '@pages/index')),
  information: lazy(() => import(/* webpackChunkName: "information" */ '@pages/information')),
  informationDetail: lazy(() =>
    import(/* webpackChunkName: "informationDetail" */ '@pages/informationDetail')
  ),
  highEndJob: lazy(() => import(/* webpackChunkName: "highEndJob" */ '@pages/jobList')),
  basicJob: lazy(() => import(/* webpackChunkName: "basicJob" */ '@pages/jobList')),
  internJob: lazy(() => import(/* webpackChunkName: "internJob" */ '@pages/jobList')),
  practiceJob: lazy(() => import(/* webpackChunkName: "practiceJob" */ '@pages/jobList')),
  jobList: lazy(() => import(/* webpackChunkName: "jobList" */ '@pages/jobList')),
  license: lazy(() => import(/* webpackChunkName: "license" */ '@pages/license')),
  login: lazy(() => import(/* webpackChunkName: "login" */ '@pages/login')),
  noFound: lazy(() => import(/* webpackChunkName: "noFound" */ '@pages/noFound')),
  record: lazy(() => import(/* webpackChunkName: "record" */ '@pages/record')),
  resume: lazy(() => import(/* webpackChunkName: "resume" */ '@pages/resume')),
  search: lazy(() => import(/* webpackChunkName: "search" */ '@pages/search')),
  shareList: lazy(() => import(/* webpackChunkName: "shareList" */ '@pages/shareList'))
}

const saasService = new SAASService()
container.saasService = saasService

if (FMT_ENV === 'dev') {
  container.console = new VConsole()
}

const isIOS = () => {
  const isIphone = window.navigator.userAgent.includes('iPhone')
  const isIpad = window.navigator.userAgent.includes('iPad')
  return isIphone || isIpad
}
// const ANIMATION_MAP = {
//   PUSH: 'forward',
//   POP: 'back'
// }

// const TransitionRoutes = withRouter(({ location, history }) => {
//   return (
//     <TransitionGroup
//       className="router-wrapper"
//       childFactory={child =>
//         React.cloneElement(child, { classNames: ANIMATION_MAP[history.action] })
//       }>
//       <CSSTransition timeout={500} key={location.pathname}>
//         <Switch location={location}>
//           {Object.keys(routes).map(key => (
//             // 循环输出Route.
//             <Route key={key} path={`/${key === 'index' ? '' : key}`} exact={key === 'index'}>
//               {props => (
//                 <WrappedComponent
//                   {...props}
//                   location={location}
//                   history={history}
//                   component={routes[key]}
//                 />
//               )}
//             </Route>
//           ))}
//           <Redirect path="/index" to="/" />
//         </Switch>
//       </CSSTransition>
//     </TransitionGroup>
//   )
// })
function App () {
  useEffect(() => {
    if (isIOS()) {
      // container.saasService.getWxSdk(window.location.href.split('#')[0]).then(res => {
      // alert(res)
      wx.config({
        debug: false
        // debug: res.debug, // 开启调试模式
        // appId: res.appId, // 必填，公众号的唯一标识
        // timestamp: res.timestamp, // 必填，生成签名的时间戳
        // nonceStr: res.nonceStr, // 必填，生成签名的随机串
        // signature: res.signature, // 必填，签名，见附录1
        // jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'] // 必填，需要使用的JS接口列表
      })
      // })
    }
  }, [])

  return (
    <BrowserRouter>
      <Switch>
        {Object.keys(routes).map(key => (
          // 循环输出Route.
          <Route key={key} path={`/${key === 'index' ? '' : key}`} exact={key === 'index'}>
            {({ location, history }) => (
              <WrappedComponent location={location} history={history} component={routes[key]} />
            )}
          </Route>
        ))}
        <Redirect path='/index' to='/' />
      </Switch>
    </BrowserRouter>
  )
}

export default App
